// Particle flow background animation for the hero section.
// Ported from React (components/particle-flow.tsx) to vanilla JS.

const CONNECTION_DISTANCE = 150
const MOUSE_RADIUS = 200
const PARTICLE_COUNT = 60

function initParticleFlow(canvasId) {
  const canvas = document.getElementById(canvasId)
  if (!canvas) return

  const ctx = canvas.getContext("2d")
  if (!ctx) return

  let particles = []
  let animationId = 0
  const mouse = { x: -1000, y: -1000 }

  function createParticles(w, h) {
    particles = []
    for (let i = 0; i < PARTICLE_COUNT; i++) {
      particles.push({
        x: Math.random() * w,
        y: Math.random() * h,
        vx: (Math.random() - 0.5) * 0.4,
        vy: (Math.random() - 0.5) * 0.4,
        radius: Math.random() * 1.5 + 1,
        opacity: Math.random() * 0.3 + 0.15,
        pulsePhase: Math.random() * Math.PI * 2,
        pulseSpeed: Math.random() * 0.02 + 0.01,
      })
    }
  }

  function resize() {
    const dpr = window.devicePixelRatio || 1
    const rect = canvas.getBoundingClientRect()
    canvas.width = rect.width * dpr
    canvas.height = rect.height * dpr
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0)

    if (particles.length === 0) {
      createParticles(rect.width, rect.height)
    }
  }

  function onMouseMove(e) {
    const rect = canvas.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    if (x < 0 || x > rect.width || y < 0 || y > rect.height) {
      mouse.x = -1000
      mouse.y = -1000
    } else {
      mouse.x = x
      mouse.y = y
    }
  }

  function animate() {
    const rect = canvas.getBoundingClientRect()
    const w = rect.width
    const h = rect.height

    ctx.clearRect(0, 0, w, h)

    const connections = []

    // Update particles
    for (let i = 0; i < particles.length; i++) {
      const p = particles[i]

      // Pulse
      p.pulsePhase += p.pulseSpeed
      const pulse = Math.sin(p.pulsePhase) * 0.11

      // Mouse interaction - particles gently drift toward cursor
      const dx = mouse.x - p.x
      const dy = mouse.y - p.y
      const dist = Math.sqrt(dx * dx + dy * dy)

      if (dist < MOUSE_RADIUS && dist > 0) {
        const force = ((MOUSE_RADIUS - dist) / MOUSE_RADIUS) * 0.008
        p.vx += (dx / dist) * force
        p.vy += (dy / dist) * force
      }

      // Damping
      p.vx *= 0.999
      p.vy *= 0.999

      // Move
      p.x += p.vx
      p.y += p.vy

      // Wrap edges
      if (p.x < -10) p.x = w + 10
      if (p.x > w + 10) p.x = -10
      if (p.y < -10) p.y = h + 10
      if (p.y > h + 10) p.y = -10

      // Find connections
      for (let j = i + 1; j < particles.length; j++) {
        const p2 = particles[j]
        const cdx = p.x - p2.x
        const cdy = p.y - p2.y
        const cdist = Math.sqrt(cdx * cdx + cdy * cdy)
        if (cdist < CONNECTION_DISTANCE) {
          connections.push({
            from: i,
            to: j,
            opacity: (1 - cdist / CONNECTION_DISTANCE) * 0.11,
          })
        }
      }

      // Draw particle
      const currentOpacity = p.opacity + pulse
      ctx.beginPath()
      ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2)
      ctx.fillStyle = `rgba(59, 130, 246, ${currentOpacity})`
      ctx.fill()

      // Outer glow
      ctx.beginPath()
      ctx.arc(p.x, p.y, p.radius * 3, 0, Math.PI * 2)
      ctx.fillStyle = `rgba(59, 130, 246, ${currentOpacity * 0.1})`
      ctx.fill()
    }

    // Draw connections (routing lines)
    for (const conn of connections) {
      const pFrom = particles[conn.from]
      const pTo = particles[conn.to]

      ctx.beginPath()
      ctx.moveTo(pFrom.x, pFrom.y)
      ctx.lineTo(pTo.x, pTo.y)
      ctx.strokeStyle = `rgba(59, 130, 246, ${conn.opacity})`
      ctx.lineWidth = 0.8
      ctx.stroke()
    }

    // "Routing" animation - bright dots traveling along connections
    const time = Date.now() * 0.001
    for (let i = 0; i < connections.length; i++) {
      if (connections[i].opacity > 0.08) {
        const progress = ((time * 0.5 + i * 0.3) % 1)
        const pFrom = particles[connections[i].from]
        const pTo = particles[connections[i].to]
        const tx = pFrom.x + (pTo.x - pFrom.x) * progress
        const ty = pFrom.y + (pTo.y - pFrom.y) * progress

        ctx.beginPath()
        ctx.arc(tx, ty, 1.5, 0, Math.PI * 2)
        ctx.fillStyle = `rgba(59, 130, 246, ${connections[i].opacity * 3})`
        ctx.fill()
      }
    }

    animationId = requestAnimationFrame(animate)
  }

  resize()
  window.addEventListener("resize", resize)
  window.addEventListener("mousemove", onMouseMove)
  animationId = requestAnimationFrame(animate)

  return function destroy() {
    cancelAnimationFrame(animationId)
    window.removeEventListener("resize", resize)
    window.removeEventListener("mousemove", onMouseMove)
  }
}

// Self-initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initParticleFlow("particle-flow"))
} else {
  initParticleFlow("particle-flow")
}
